import {useState, useCallback} from "react";
import {useDispatch} from "react-redux";
import {useDisclosure} from "../../../hooks/useDisclosure";
import {deleteEventRule} from "../../../redux/Actions/eventRule.actions";

export const useEventRulesTableActions = (fetchAfterDelete = () => {}) => {
  const {
    isOpen: isEditModalOpen,
    onOpen: openEditModal,
    onClose: closeEditModal,
  } = useDisclosure();
  const {
    isOpen: isDeleteModalOpen,
    onOpen: openDeleteModal,
    onClose: closeDeleteModal,
  } = useDisclosure();
  const dispatch = useDispatch();
  const [selectedRow, setSelectedRow] = useState(null);

  const clearSelectedRow = () => setSelectedRow(null);

  const handleActionSelection = useCallback(
    (action, data) => {
      setSelectedRow({
        ...data,
        conditions: data.conditions ? JSON.stringify(data.conditions, null, 2) : "",
      });
      switch (action) {
        case "Edit":
          openEditModal();
          break;
        case "Delete":
          openDeleteModal();
          break;
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const handleDelete = () => {
    const callback = () => {
      closeDeleteModal();
      clearSelectedRow();
      fetchAfterDelete();
    };
    dispatch(deleteEventRule(selectedRow.id, callback));
  };

  const handleDeleteModalClose = () => {
    closeDeleteModal();
    clearSelectedRow();
  };

  const handleEditModalClose = () => {
    closeEditModal();
    clearSelectedRow();
  };

  return {
    closeDeleteModal: handleDeleteModalClose,
    closeEditModal: handleEditModalClose,
    handleActionSelection,
    handleDelete,
    isDeleteModalOpen,
    isEditModalOpen,
    selectedRow,
  };
};
